import { render, staticRenderFns } from "./page13.vue?vue&type=template&id=65297bfc&scoped=true&"
import script from "./page13.vue?vue&type=script&lang=js&"
export * from "./page13.vue?vue&type=script&lang=js&"
import style0 from "./page13.vue?vue&type=style&index=0&id=65297bfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65297bfc",
  null
  
)

export default component.exports